import axios from 'axios'
import qs from 'qs'

export const cohortService = ({
  getCohortList (token, groupId) {
    return axios.get('/api/GroupCourseCohorts/ListByGroup?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },

  /**
   * This is added for the Client Dashboard. It returns Cohort
   * information on a per GroupCourse basis. Cohorts for the
   * same GroupCourse are all wrapped together in an array.
   *
   * @param String token
   * @param String groupId
   */
  getCohortListV2 (token, groupId) {
    return axios.get('/api/GroupCourseCohorts/ListByGroup2?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getCohortListUsingGroupCourse (token, groupCourseMasterId) {
    return axios.get('/api/GroupCourseCohorts/ListByGroupCourse?groupCourseMasterId=' + groupCourseMasterId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateCohort (token, cohortObj) {
    var stringifiedObj = qs.stringify(cohortObj)
    return axios.put('/api/GroupCourseCohort/Update', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteCohort (token, cohortId) {
    return axios.delete('/api/GroupCourseCohort/Delete?cohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getParticipantList (token, cohortId, groupId = null) {
    return axios.get(`/api/GroupCourseCohort/Users?showcert=true&cohortId=${cohortId}&groupId=${groupId}`, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getM365ParticipantList (token, groupId, groupCourseMasterId, cohortId) {
    return axios.get(`/api/GroupCourseCohort/M365Users?groupId=${groupId}&groupCourseMasterId=${groupCourseMasterId}&cohortId=${cohortId}`, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAllCohortList (token) {
    return axios.get('/api/GroupCourseCohorts/ListAll', {headers: {'Authorization': 'Bearer ' + token}})
  },
  createCohort (token, cohortObj) {
    var stringifiedObj = qs.stringify(cohortObj)
    return axios.post('/api/GroupCourseCohort/Create', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAvailableChallenges (token) {
    return axios.get('/api/leaps/availablecohortchallenges', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAvailableChallengeForCohort (token, cohortId) {
    return axios.get('/api/leaps/availablecohortchallenge?cohortId=' + cohortId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  associateCohortWithLeapsChallenges (token, objToPass) {
    return axios.post('/api/leaps/availablecohortchallenges', objToPass, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateAssociateCohortWithLeapsChallenges (token, objToPass) {
    return axios.put('/api/leaps/availablecohortchallenges', objToPass, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteAssociatedLeapsChallengeFromCohort (token, availableCohortChallengesId) {
    return axios.delete('/api/leaps/availablecohortchallenges?AvailableCohortChallengesId=' + availableCohortChallengesId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAvailableActions (token) {
    return axios.get('/api/leaps/availablecohortactions', {headers: {'Authorization': 'Bearer ' + token}})
  },
  associateCohortWithLeapsActions (token, objToPass) {
    return axios.post('/api/leaps/availablecohortactions', objToPass, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteAssociatedLeapsActionFromCohort (token, availableCohortActionsId) {
    return axios.delete('/api/leaps/availablecohortactions?AvailableCohortActionsId=' + availableCohortActionsId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/cohort-service.js